import script from "./MaterialDeleteButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialDeleteButton.vue?vue&type=script&setup=true&lang=js"

import "./MaterialDeleteButton.vue?vue&type=style&index=0&id=56337fca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56337fca"]])

export default __exports__